import { useRef } from "react";
import { ClockIcon, DocumentIcon, Signer } from "assets/icons";
import Chip from "components/chip/chip";
import useModal from "components/modal/useModal";
import { getInterimPdfUrl } from "helper/interimPdfUrl";
import {
  getContractAvenantNumber,
  getContractFileName,
} from "helper/contractFileName";
import { dateWordShort } from "helper/helper";
import { fetchSignatureLink } from "helper/signatureLink";
import UseContext from "hooks/useContext";

const Tbodycontract = ({ champsBody, filterStatus }) => {
  const { toggle } = useModal();
  const isFetchingSignatureLink = useRef(false);
  const rUser = localStorage.getItem("rUser");
  const { setSignatureLink, setDataYousign } = UseContext();
  const colorContract = {
    0: "ALERT",
    1: "INFO",
  };
  const contentContract = {
    0: "À signer",
    1: "Signé",
  };
  const handleSign = (e, contract, item, missionObjectId) => {
    e.preventDefault();
    if (isFetchingSignatureLink.current) return;
    isFetchingSignatureLink.current = true;
    console.clear();

    setDataYousign({
      yousign_id: contract.yousign_id,
      contract_id: contract._id,
      mission_id: item,
      filename: contract.fileName,
      filepath: contract.filePath,
    });
    setSignatureLink("");
    toggle("doc_c_signature");
    fetchSignatureLink({ idMission: missionObjectId, contract })
      .then(setSignatureLink)
      .finally(() => {
        isFetchingSignatureLink.current = false;
      });
  };

  return (
    <>
      {champsBody?.map((item) => {
        // JBWEB-1089: assigned, but nothing to sign yet — the row says a
        // contract is coming rather than leaving the mission out of the list.
        if (item.contract_pending) {
          return (
            <tr key={item._id} className="border-b-2 border-gray-100">
              <td className="m-3">—</td>
              <td className="m-3">
                {item.companyCollection?.[0]?.name_commercial || ""}
              </td>
              <td className="m-3">{item.title}</td>
              <td className="m-3">{item.id_mission}</td>
              <td className="m-3">
                <Chip type="INDICATOR" color="PRIMARY">
                  Bientôt disponible
                </Chip>
              </td>
              <td className="m-3">{dateWordShort(item.duration?.datestart)}</td>
              <td className="m-3 flex items-center justify-center">
                <ClockIcon wh={20} color="#9CA3AF" />
              </td>
            </tr>
          );
        }

        return item.contract_tempworker
          .filter((c) => !filterStatus || c.status === filterStatus)
          .map((contract, idx) => {
          const avenantNum = getContractAvenantNumber(contract);
          const label = contract.id_bestt
            ? avenantNum > 0
              ? `${contract.id_bestt} - ${avenantNum}`
              : String(contract.id_bestt)
            : "—";

          return (
            <tr key={contract._id || idx} className="border-b-2 border-gray-100">
              <td className="m-3">{label}</td>
              <td className="m-3">
                {item.companyCollection?.[0]?.name_commercial || ""}
              </td>
              <td className="m-3">{item.title}</td>
              <td className="m-3">{item.id_mission}</td>
              <td className="m-3">
                <Chip type="INDICATOR" color={colorContract[contract.status]}>
                  {contentContract[contract.status]}
                </Chip>
              </td>
              <td className="m-3">{dateWordShort(contract.createdAt)}</td>
              <td className="m-3 flex items-center justify-center">
                {contract.status === "0" && rUser !== "200" ? (
                  <span
                    onClick={(e) =>
                      handleSign(e, contract, item.id_mission, item._id)
                    }
                  >
                    <Signer wh={24} />
                  </span>
                ) : (
                  <a
                    target="_blank"
                    href={getInterimPdfUrl({
                      type: "contract",
                      fileName: getContractFileName(item.id_mission, contract),
                    })}
                  >
                    <DocumentIcon wh={35} color="#111827" />
                  </a>
                )}
              </td>
            </tr>
          );
        });
      })}
    </>
  );
};

export default Tbodycontract;
